import axios from '../axios';
import { CustomErrorResponse } from '../types/customError/response';
import { SubscriptionType } from '../types/subscriptionType/response';

/*
  @param {number} subscriptionTypeId: If required
  @return {Promise<SubscriptionTypeResponse[] | CustomErrorResponse>}
*/
export const fetchSubscriptionTypes = async (
  subscriptionTypeId: number | undefined,
): Promise<SubscriptionType[] | CustomErrorResponse> => {
  try {
    const response = await axios.get(
      `/subscription/subscriptionType${
        subscriptionTypeId ? `?subscriptionTypeId=${subscriptionTypeId}` : ''
      }`,
    );
    return response.data.data;
  } catch (err) {
    console.log(err);
    const error: CustomErrorResponse = {
      data: err,
      message: 'Error',
      errorCode: 400,
      statusCode: 400,
    };

    return error;
  }
};
